import { render, staticRenderFns } from "./UploadBatch.vue?vue&type=template&id=245be669&scoped=true"
import script from "./UploadBatch.vue?vue&type=script&lang=js"
export * from "./UploadBatch.vue?vue&type=script&lang=js"
import style0 from "./UploadBatch.vue?vue&type=style&index=0&id=245be669&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245be669",
  null
  
)

export default component.exports